import m from "../../geodata/es2015/greenlandLow";
window.am4geodata_greenlandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/greenlandLow.js
// module id = null
// module chunks = 